/**
 * TanStack Router: /revfinops/payables
 *
 * This route file was auto-generated by the route generation script.
 * Component: RevFinOpsPayablesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import RevFinOpsPayablesPage from '@/app/revfinops/payables/page'

/**
 * Route: /revfinops/payables
 * Layout: _auth (authenticated)
 * Component: RevFinOpsPayablesPage
 */
export const Route = createFileRoute('/_auth/revfinops/payables')({
  component: RevFinOpsPayablesPage,
})
